/**
 * DataTables 한글 초성 검색 플러그인
 *
 * - 순수 초성 입력 (ㄱㅎㅅ) → 초성만으로 매칭 ("김현수")
 * - 혼합 입력 (김ㅎ)       → 글자별 초성+완성형 매칭 ("김현수")
 * - 일반 텍스트            → DataTables 기본 검색
 *
 * client-side DataTable에만 적용 (serverSide: true 테이블은 건너뜀)
 */
(function ($) {
    'use strict';

    /* ── 초성 매핑 테이블 ── */
    var CHO = [
        'ㄱ','ㄲ','ㄴ','ㄷ','ㄸ','ㄹ','ㅁ','ㅂ','ㅃ',
        'ㅅ','ㅆ','ㅇ','ㅈ','ㅉ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ'
    ];
    var BASE  = 0xAC00;   // '가'
    var PERIOD = 588;      // 21(중성) × 28(종성)

    /* ── 유틸 함수 ── */

    /** 한글 완성형 → 초성, 그 외 → 원문 그대로 */
    function cho(ch) {
        var c = ch.charCodeAt(0);
        return (c >= 0xAC00 && c <= 0xD7A3)
            ? CHO[Math.floor((c - BASE) / PERIOD)]
            : ch;
    }

    /** 문자열 전체 → 초성 문자열 */
    function toCho(s) {
        for (var i = 0, r = ''; i < s.length; i++) r += cho(s[i]);
        return r;
    }

    /** 해당 문자가 초성(자음)인지 */
    function isCho(ch) { return CHO.indexOf(ch) !== -1; }

    /** 문자열이 초성+공백으로만 구성됐는지 */
    function allCho(s) {
        var t = s.replace(/\s/g, '');
        if (!t) return false;
        for (var i = 0; i < t.length; i++) {
            if (!isCho(t[i])) return false;
        }
        return true;
    }

    /** 문자열에 초성이 하나라도 포함됐는지 */
    function hasCho(s) {
        for (var i = 0; i < s.length; i++) {
            if (isCho(s[i])) return true;
        }
        return false;
    }

    /**
     * 혼합 매칭: 검색어의 각 글자가
     *   - 초성이면 → 대상 글자의 초성과 비교
     *   - 완성형이면 → 대상 글자와 직접 비교 (대소문자 무시)
     */
    function matchMixed(text, term) {
        var tLen = term.length;
        if (tLen === 0) return true;
        outer:
        for (var i = 0, end = text.length - tLen; i <= end; i++) {
            for (var j = 0; j < tLen; j++) {
                var tc = term[j], sc = text[i + j];
                if (isCho(tc)) {
                    if (cho(sc) !== tc) continue outer;
                } else {
                    if (sc.toLowerCase() !== tc.toLowerCase()) continue outer;
                }
            }
            return true;
        }
        return false;
    }

    /* ── 상태 저장 (테이블별) ── */
    var _state = {};   // { tableId: { term: '', mode: 'off'|'cho'|'mixed' } }

    /* ── DataTables 글로벌 필터 ── */
    $.fn.dataTable.ext.search.push(function (settings, data) {
        var st = _state[settings.sTableId];
        if (!st || st.mode === 'off') return true;   // 초성 검색 비활성 → 통과

        var term = st.term.replace(/\s/g, '');
        if (!term) return true;

        for (var i = 0; i < data.length; i++) {
            // HTML 태그 제거 후 순수 텍스트
            var cell = data[i].replace(/<[^>]*>/g, '');
            if (st.mode === 'cho') {
                // 순수 초성 모드: 셀 텍스트의 초성과 비교
                if (toCho(cell).indexOf(term) !== -1) return true;
            } else {
                // 혼합 모드: 글자별 비교
                if (matchMixed(cell, st.term)) return true;
            }
        }
        return false;
    });

    /* ── 각 DataTable 초기화 시 검색 입력 가로채기 ── */
    $(document).on('init.dt', function (e, settings) {
        if (e.namespace !== 'dt') return;
        if (settings.oFeatures.bServerSide) return;  // 서버사이드는 건너뜀

        var tableId = settings.sTableId;
        var api = new $.fn.dataTable.Api(settings);
        var $input = $(api.table().container()).find('.dataTables_filter input');

        if (!$input.length) return;

        _state[tableId] = { term: '', mode: 'off' };

        // DataTables 기본 검색 이벤트 해제
        $input.off('keyup.DT input.DT');

        // 커스텀 검색 이벤트 바인딩
        $input.on('input.chosung', function () {
            var val = (this.value || '').trim();

            if (!val) {
                // 빈 검색어 → 전부 초기화
                _state[tableId] = { term: '', mode: 'off' };
                api.search('').draw();
            } else if (allCho(val)) {
                // 순수 초성 ("ㄱㅎㅅ")
                _state[tableId] = { term: val, mode: 'cho' };
                api.search('').draw();        // 네이티브 검색 비우고, 커스텀 필터로 draw
            } else if (hasCho(val)) {
                // 혼합 ("김ㅎ")
                _state[tableId] = { term: val, mode: 'mixed' };
                api.search('').draw();
            } else {
                // 일반 텍스트 → DataTables 기본 검색
                _state[tableId] = { term: '', mode: 'off' };
                api.search(val).draw();
            }
        });
    });

})(jQuery);
